module.exports = __webpack_public_path__ + "static/media/Icon feather-log-out.60780822.svg";